import React from "react";

const StatisticItem = ({
  statisticIcon,
  statisticLabel,
  statisticDescription,
  totalClaimed,
  totalUsdt,
}) => {
  return (
    <article className="p-6 rounded-3xl bg-white h-full dark:bg-darkCardBg">
      <div className="mb-5 flex items-center gap-[10px]">
        <div className="w-[38px] h-[38px] flex justify-center items-center bg-iceBlue dark:bg-[#1D1C2D] dark:border dark:border-deepBlue rounded-lg">
          {statisticIcon}
        </div>
        <div>
          <h4 className="text-xs leading-[14px] text-semiBlack dark:text-semiWhite">
            Analytics
          </h4>
          <p className="font-semibold leading-6 text-xl text-black dark:text-white">
            {statisticLabel}
          </p>
        </div>
      </div>
      <div>
        <p className="mb-2 text-semiBlack dark:text-semiWhite text-xs leading-[14px] h-[28px] custom1402:h-fit tracking-[0.015em]">
          {statisticDescription}
        </p>
        <p className="text-black dark:text-white font-semibold leading-6 text-xl">{`${
          totalClaimed === "0.00" ? "00.00" : totalClaimed
        } XBR`}</p>
        <p className="text-semiBlack dark:text-semiWhite text-sm leading-6">{`≈ ${
          totalUsdt === "0.00" || totalUsdt === 0 ? "00.00" : totalUsdt
        }$`}</p>
      </div>
    </article>
  );
};

export default StatisticItem;
